import * as $account from './_account'
import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $loading from './_loading'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $resources from './_resources'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    returnTo: string
    code: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    // if code was passed in, login immediately
    if (options.code?.length) {
        $account.login.doLogInUsingToken({
            code: options.code,
            onComplete: function () {
                $loading.show('Du har loggats in! Går vidare till söksidan...')
                location.href = $resources.url.search.owner
            },
        })
    }

    var btn = $('#' + options.pagePrefix + '-btn')
    var un = $('#' + options.pagePrefix + '-email')
    var pw = $('#' + options.pagePrefix + '-password')
    var ca = $('#' + options.pagePrefix + '-captcha')

    if (un.val().length > 0) {
        pw.focus()
    } else {
        un.focus()
    }

    un.bind('keyup', function (e) {
        var code = e.keyCode || e.which
        if (code == 13) {
            btn.trigger('click')
        }
    })

    pw.bind('keyup', function (e) {
        var code = e.keyCode || e.which
        if (code == 13) {
            btn.trigger('click')
        }
    })

    ca.bind('keyup', function (e) {
        var code = e.keyCode || e.which
        if (code == 13) {
            btn.trigger('click')
        }
    })

    btn.click(function () {
        $msg.hide()

        $account.login.doLogIn({
            email: un.val(),
            password: pw.val(),
            captcha: ca.val(),
            onComplete: function () {
                $loading.show('Du har loggats in! Går vidare till söksidan...')
                location.href =
                    options.returnTo && options.returnTo.length > 0
                        ? options.returnTo
                        : $resources.url.search.owner
            },
        })
    })

    $('#' + options.pagePrefix + '-forgotten-password-link').click(function () {
        var email = prompt('Ange ditt kontos användarnamn eller e-postadress:', un.val())

        $msg.hide()

        $ajax.post({
            loadingText: 'Skickar mail...',
            url: $resources.url.account.forgottenPassword,
            data: {
                email: email,
            },
            success: function (res) {
                if (res.Ok) {
                    $msg.show(res.Message)
                } else {
                    $msg.showError(res.Message)
                }
            },
        })
    })

    $('#' + options.pagePrefix + '-reset-code-link').click(function () {
        sendResetCodeLink()
    })

    $helpers.makeCaptchaReloadable($('#' + options.pagePrefix + '-captcha-image'))
}

export function sendResetCodeLink() {
    $msg.hide()
    $modal.hide()

    var un = $('#' + options.pagePrefix + '-email')
    var pw = $('#' + options.pagePrefix + '-password')
    var ca = $('#' + options.pagePrefix + '-captcha')

    $ajax.post({
        loadingText: 'Skickar mail...',
        url: $resources.url.account.sendDeleteCodeMail,
        data: {
            username: un.val(),
            password: pw.val(),
            captcha: ca.val(),
        },
        success: function (res) {
            console.log(res)
            if (res.Ok) {
                $msg.show(res.Message)
            } else {
                $msg.showError(res.Message)
            }
        },
    })
}
